module.exports = __webpack_public_path__ + "static/assets/f8a2e815f324722297942693294f598e.png";